<div class="filter-list" [class.filter-list--compact]="compact">
  <!-- Fuel -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Fuel</h2>
    <div class="filter-list__group-content">
      <app-checkbox-filter [filter]="fuel100LLFilter" label="100LL" [compact]="compact" (change)="fuelChange($event, '100LL')">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="fuelJetAFilter" label="Jet-A" [compact]="compact" (change)="fuelChange($event, 'JetA')">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="fuelMOGASFilter" label="MOGAS" [compact]="compact" (change)="fuelChange($event, 'MOGAS')">
      </app-checkbox-filter>
      <app-checkbox-filter [filter]="fuelUL94Filter" label="UL94" [compact]="compact" (change)="fuelChange($event, 'UL94')">
      </app-checkbox-filter>
    </div>
  </div>

  <!-- Airport Amenities -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Airport Amenities</h2>
    <div class="filter-list__group-content">
      <app-checkbox-filter [filter]="query.getFilter(FilterKeys.PublicUse)" label="Public Use" fontSet="fa"
                           (change)="onPublicUseChanged()" fontIcon="fa-globe" [compact]="compact">
      </app-checkbox-filter>
    </div>
  </div>
</div>
